export default "__VITE_ASSET__Cu91IiMJ__"